<div class="card">
    <div class="card-header bg-transparent border-bottom"> Item Details</div>
    <div class="card-body" [formGroup]="performaDetailsForm">
        <div class="row">
            <div class="col-md-2">
                <label for="description" class="form-label">Description<span class="mandatory">*</span></label>
                <input type="text" class="form-control form-control-sm" id="description" 
                    formControlName="txtDescription" placeholder="Search or Enter Description" [resultTemplate]="rt"
                    [inputFormatter]="formatter" [ngbTypeahead]="searchperforma"
                    (selectItem)="selectedItemEventPerformaDescription($event)"
                    [ngClass]="{'is-invalid': (isPerformaDetailsFormSubmit || performaDetailsForm.get('txtDescription')?.touched) && performaDetailsForm.get('txtDescription')?.errors}" >
                <div *ngIf="(isPerformaDetailsFormSubmit || performaDetailsForm.get('txtDescription')?.touched) && performaDetailsForm.get('txtDescription')?.errors"
                    class="invalid-feedback">
                    <span *ngIf="performaDetailsForm.get('txtDescription').errors.required">Description is
                        Required</span>
                </div>
                <div *ngIf="(isPerformaDetailsFormSubmit || performaDetailsForm.get('txtDescription')?.touched) && performaDetailsForm.get('txtDescription')?.errors"
                    class="invalid-feedback">
                    <span *ngIf="performaDetailsForm.get('txtDescription').errors.maxlength">Description max length is
                        40 characters</span>
                </div>
                <ng-template #rt let-r="result" let-t="term">
                    <ngb-highlight [result]="r.name" [term]="t"></ngb-highlight>
                    <span> | {{r['hsncode']}}</span>
                </ng-template>
            </div>
            <div class="col-md-1">
                <label for="hsncode" class="form-label">HSN Code</label>
                <input type="text" class="form-control form-control-sm" id="hsncode" formControlName="txtHSNCode"
                    [ngClass]="{'is-invalid': (isPerformaDetailsFormSubmit || performaDetailsForm.get('txtHSNCode')?.touched) && performaDetailsForm.get('txtHSNCode')?.errors}" >
                <div *ngIf="(isPerformaDetailsFormSubmit || performaDetailsForm.get('txtHSNCode')?.touched) && performaDetailsForm.get('txtHSNCode')?.errors"
                    class="invalid-feedback">
                    <span *ngIf="performaDetailsForm.get('txtHSNCode').errors.maxlength">HSN Code max length is 10
                        characters</span>
                </div>
            </div>
            <div class="col-md-2">
                <label for="unit" class="form-label">Unit</label>
                <ng-select formControlName="ddlUnit" [items]="performaUnitOptions" bindLabel="name" [bindValue]="'code'"
                    placeholder="Select" [appendTo]="'body'" [openOnEnter]="false" ></ng-select>
            </div>
            <div class="col-md-1">
                <label for="weight" class="form-label">Weight</label>
                <input type="number" class="form-control form-control-sm" id="weight" formControlName="txtWeight"
                    [ngClass]="{'is-invalid': (isPerformaDetailsFormSubmit || performaDetailsForm.get('txtWeight')?.touched) && performaDetailsForm.get('txtWeight')?.errors}" >
                <div *ngIf="(isFormSubmitted || performaDetailsForm.get('txtWeight').touched) && performaDetailsForm.get('txtWeight').errors"
                    class="invalid-feedback">
                    <span *ngIf="performaDetailsForm.get('txtWeight').errors.pattern">Please enter a number with up to
                        10 digits and at most two decimal places.</span>
                </div>
            </div>

            

            <div class="col-md-1">
                <label for="quantity" class="form-label">Quantity<span class="mandatory">*</span></label>
                <input type="number" class="form-control form-control-sm" id="quantity" formControlName="txtQuantity"
                    (keyup)="calculatePerformAmount()" (keydown)="onKeyDown($event)"
                    [ngClass]="{'is-invalid': (isPerformaDetailsFormSubmit || performaDetailsForm.get('txtQuantity')?.touched) && performaDetailsForm.get('txtQuantity')?.errors}" >
                <div *ngIf="(isPerformaDetailsFormSubmit || performaDetailsForm.get('txtQuantity')?.touched) && performaDetailsForm.get('txtQuantity')?.errors"
                    class="invalid-feedback">
                    <span *ngIf="performaDetailsForm.get('txtQuantity').errors.required">Quantity is Required</span>
                </div>

                <div *ngIf="(isPerformaDetailsFormSubmit || performaDetailsForm.get('txtQuantity')?.touched) && performaDetailsForm.get('txtQuantity')?.errors"
                    class="invalid-feedback">
                    <span *ngIf="performaDetailsForm.get('txtQuantity').errors.pattern">Please enter up to 3
                        digits.</span>
                </div>
            </div>

            <div class="col-md-1">
                <label for="rate" class="form-label">Rate<span class="mandatory">*</span></label>
                <input type="number" class="form-control form-control-sm" id="rate" formControlName="txtRate"
                    (keyup)="calculatePerformAmount()"
                    [ngClass]="{'is-invalid': (isPerformaDetailsFormSubmit || performaDetailsForm.get('txtRate')?.touched) && performaDetailsForm.get('txtRate')?.errors}" >
                <div *ngIf="(isPerformaDetailsFormSubmit || performaDetailsForm.get('txtRate')?.touched) && performaDetailsForm.get('txtRate')?.errors"
                    class="invalid-feedback">
                    <span *ngIf="performaDetailsForm.get('txtRate').errors.required">Rate is Required</span>
                </div>
                <div *ngIf="(isPerformaDetailsFormSubmit || performaDetailsForm.get('txtRate')?.touched) && performaDetailsForm.get('txtRate')?.errors"
                    class="invalid-feedback">
                    <span *ngIf="performaDetailsForm.get('txtRate').errors.pattern">Please enter a number with up to 10
                        digits and at most two decimal places.</span>
                </div>
            </div>



            <div class="col-md-1">
                <label for="amount" class="form-label">Amount</label>
                <input type="number" class="form-control form-control-sm" id="amount" formControlName="txtAmount" >
            </div>

            <div class="col-md-2">
                <div class="mb-2">
                    <label for="uploaddoc" class="form-label"></label>
                    <div *ngIf="!isPerfromDetailsEdit">
                        <button type="button" class="btn btn-primary btn-sm d-flex"
                            (click)="isPerformaDetailsFormSubmit=true;addPerforma()">
                            <i class="bx bx-plus font-size-16 me-2"></i>
                            Add
                        </button>
                    </div>
                    <div *ngIf="isPerfromDetailsEdit">
                        <button type="button" class="btn btn-primary btn-sm"
                            (click)="isPerfromDetailsEdit=false;updatePerforma()">
                            Update
                        </button>
                        <button type="button" class="btn btn-secondary btn-sm"
                            (click)="isPerfromDetailsEdit=false;resetPerforma()">
                            cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-3">
            <div class="row">
                <div class="col-mb-12">
                    <div class="table-responsive">
                        <div class="table table-sm m-0">
                            <thead class="table-light">
                                <tr>
                                    <th>Description</th>
                                    <th>HSN Code</th>
                                    <th>Weight</th>
                                    <th>Unit</th>
                                    <th>Rate</th>
                                    <th>Quantity</th>
                                    <th>Amount</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let performa of performaData;let i=index">
                                    <ng-container *ngIf="performa.piecesid === piecesId">
                                        <th>{{performa.description}}</th>
                                        <th>{{performa.hsncode}}</th>
                                        <th>{{performa.weight}}</th>
                                        <th>{{getUnitValue(performa.unit)}}</th>
                                        <th>{{performa.rate}}</th>
                                        <th>{{performa.quantity}}</th>
                                        <th>{{performa.amount}}</th>
                                        <th class="d-flex">
                                            <i class="bx bx-edit font-size-16 align-middle me-2"
                                                (click)="getPerforma(performa)"></i>
                                            <i class="bx bx-trash font-size-16 align-middle me-2"
                                                (click)="deletePerforma(i)"></i>
                                        </th>
                                    </ng-container>
                                </tr>
                            </tbody>

                            <tbody *ngIf="performaData?.length===0">
                                <tr>
                                    <td colspan="12" class="no-data-available">No data available</td>
                                </tr>
                            </tbody>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <!-- <ag-grid-angular #agGrid style="width:100%;height:100%" id="myGrid" class="ag-theme-balham"
    [rowData]="data" [columnDefs]="columnDefs" [animateRows]="true" [context]="context"
    [defaultColDef]="defaultColDef" [suppressMenuHide]="true"  [pagination]="true" (gridReady)="onGridReady($event)" [gridOptions]="gridOptions">
    ></ag-grid-angular> -->
</div>